import React from 'react';
import UltimateNavbar from '../components/ultimate/UltimateNavbar';
import UltimateHero from '../components/ultimate/UltimateHero';
import UltimateAbout from '../components/ultimate/UltimateAbout';
import UltimateProblems from '../components/ultimate/UltimateProblems';
import UltimateServices from '../components/ultimate/UltimateServices';
import UltimateTestimonials from '../components/ultimate/UltimateTestimonials';
import UltimateWhyChoose from '../components/ultimate/UltimateWhyChoose';
import UltimateContact from '../components/ultimate/UltimateContact';
import UltimateFooter from '../components/ultimate/UltimateFooter';
import { 
  ExitIntentPopup, 
  CountdownTimer,
  SuccessCounter
} from '../components/ultimate/ConversionWidgets';
import {
  AggressiveFloatingCTA,
  UrgencyCounter
} from '../components/ultimate/HighConvertingWidgets';
import './UltimatePage.css';
import './ThemeOverride.css';

const UltimatePage = () => {
  return (
    <div className="ultimate-page pb-20 md:pb-0" data-testid="ultimate-page">
      {/* Top Bars */}
      <UrgencyCounter />
      
      {/* Floating Elements */}
      <ExitIntentPopup />
      <AggressiveFloatingCTA />
      
      {/* Navigation */}
      <UltimateNavbar />
      
      {/* Hero Section */}
      <div className="pt-10">
        <UltimateHero />
      </div>
      
      {/* About Section */}
      <UltimateAbout />
      

      <div className="relative w-full overflow-hidden flex items-center justify-center" data-testid="single-skull-band" style={{ minHeight: '38vh', maxHeight: '52vh' }}>
        <img src="/img/a0415570.webp" alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, rgba(11,11,14,0.28) 30%, rgba(11,11,14,0.45) 70%, #0B0B0E 100%)' }} />
        <div className="relative z-10 text-center px-6 py-16">
          <h3 className="text-2xl sm:text-4xl font-black mb-2" style={{ color: '#F0DCA0', textShadow: '0 3px 18px #000, 0 0 40px rgba(0,0,0,0.9)', fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif" }}>जहाँ दुनिया हार मानती है</h3>
          <p className="text-sm sm:text-base font-bold tracking-widest" style={{ color: '#E8E2D6', textShadow: '0 2px 12px #000' }}>वहीं से अघोर विद्या शुरू होती है</p>
        </div>
      </div>


      <div className="relative w-full overflow-hidden" data-testid="skull-band" style={{ maxHeight: '46vh' }}>
        <img src="/img/e9c8d231.webp" alt="" className="w-full object-cover" style={{ maxHeight: '46vh' }} loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, transparent 22%, transparent 78%, #0B0B0E 100%)' }} />
        <p className="absolute bottom-3 left-0 right-0 text-center text-sm sm:text-base font-bold tracking-widest" style={{ color: '#E2C170', textShadow: '0 2px 10px #000', fontFamily: "'Tiro Devanagari Hindi', serif" }}>अघोर साधना — शमशान की शक्ति</p>
      </div>

      {/* Problems Section */}
      <UltimateProblems />
      
      {/* Services Section */}
      <UltimateServices />
      

      <div className="relative w-full overflow-hidden flex items-center justify-center" data-testid="double-skull-band" style={{ minHeight: '38vh', maxHeight: '52vh' }}>
        <img src="/img/f23bdf5a.webp" alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, rgba(11,11,14,0.28) 30%, rgba(11,11,14,0.45) 70%, #0B0B0E 100%)' }} />
        <div className="relative z-10 text-center px-6 py-16">
          <h3 className="text-2xl sm:text-4xl font-black mb-2" style={{ color: '#F0DCA0', textShadow: '0 3px 18px #000, 0 0 40px rgba(0,0,0,0.9)', fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif" }}>हज़ारों बंधन काटे गए</h3>
          <p className="text-sm sm:text-base font-bold tracking-widest" style={{ color: '#E8E2D6', textShadow: '0 2px 12px #000' }}>शमशान साक्षी है — 25+ वर्षों की सिद्धि</p>
        </div>
      </div>


      <div className="relative w-full overflow-hidden flex items-center justify-center" data-testid="mata-meditate-band" style={{ minHeight: '42vh', maxHeight: '58vh' }}>
        <img src="/img/b9af3316.webp" alt="माता मलिहा साधना" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, rgba(11,11,14,0.18) 32%, rgba(11,11,14,0.4) 72%, #0B0B0E 100%)' }} />
        <div className="relative z-10 text-center px-6 py-16 mt-24">
          <h3 className="text-2xl sm:text-4xl font-black mb-1" style={{ color: '#FFE9A8', textShadow: '0 3px 18px #000, 0 0 40px #000', fontFamily: "'Yatra One', serif" }}>शमशान साधना में लीन — माता मलिहा</h3>
          <p className="text-sm sm:text-base font-bold tracking-widest" style={{ color: '#EFE9DC', textShadow: '0 2px 12px #000' }}>25+ वर्षों की अखंड अघोर साधना</p>
        </div>
      </div>

      {/* Testimonials */}
      <UltimateTestimonials />
      

      <div className="relative w-full overflow-hidden" data-testid="havan-band" style={{ maxHeight: '46vh' }}>
        <img src="/img/6d6c6641.webp" alt="" className="w-full object-cover" style={{ maxHeight: '46vh' }} loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, transparent 22%, transparent 78%, #0B0B0E 100%)' }} />
        <p className="absolute bottom-3 left-0 right-0 text-center text-sm sm:text-base font-bold tracking-widest" style={{ color: '#E2C170', textShadow: '0 2px 10px #000', fontFamily: "'Tiro Devanagari Hindi', serif" }}>हवन एवं गुप्त अनुष्ठान — माता जी की सिद्ध विधि</p>
      </div>

      {/* Why Choose Us */}
      <UltimateWhyChoose />
      
      {/* Success Counter */}
      <div className="container mx-auto px-4 max-w-4xl">
        <SuccessCounter />
      </div>
      

      <div className="relative w-full overflow-hidden flex items-center justify-center" data-testid="yantra-band" style={{ minHeight: '38vh', maxHeight: '52vh' }}>
        <img src="/img/815ed57f.webp" alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, rgba(11,11,14,0.28) 30%, rgba(11,11,14,0.45) 70%, #0B0B0E 100%)' }} />
        <div className="relative z-10 text-center px-6 py-16">
          <h3 className="text-2xl sm:text-4xl font-black mb-2" style={{ color: '#F0DCA0', textShadow: '0 3px 18px #000, 0 0 40px rgba(0,0,0,0.9)', fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif" }}>सिद्ध यंत्र एवं प्रसाद</h3>
          <p className="text-sm sm:text-base font-bold tracking-widest" style={{ color: '#E8E2D6', textShadow: '0 2px 12px #000' }}>साधना पूर्ण होने पर आपके घर पहुँचेगा</p>
        </div>
      </div>

      {/* Countdown Timer */}
      <div className="container mx-auto px-4 max-w-2xl py-8">
        <CountdownTimer />
      </div>
      
      {/* Contact Form */}

      <div className="relative w-full overflow-hidden flex items-center justify-center" data-testid="diya-band" style={{ minHeight: '38vh', maxHeight: '52vh' }}>
        <img src="/img/c4cf9bac.webp" alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, rgba(11,11,14,0.28) 30%, rgba(11,11,14,0.45) 70%, #0B0B0E 100%)' }} />
        <div className="relative z-10 text-center px-6 py-16">
          <h3 className="text-2xl sm:text-4xl font-black mb-2" style={{ color: '#F0DCA0', textShadow: '0 3px 18px #000, 0 0 40px rgba(0,0,0,0.9)', fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif" }}>अघोर विद्या — पूर्ण श्रद्धा से ही आएं</h3>
          <p className="text-sm sm:text-base font-bold tracking-widest" style={{ color: '#E8E2D6', textShadow: '0 2px 12px #000' }}>माता मलीहा जी आपकी प्रतीक्षा कर रही हैं</p>
        </div>
      </div>

      <UltimateContact />
      
      {/* Footer */}
      <UltimateFooter />
    </div>
  );
};

export default UltimatePage;
